/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */

((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const h = 'is-hidden';
	const $path = location.pathname;
	let basePath = $path.split('/')[1];
	const noResultsMsgList = {
		en: 'No products match your search options.',
		cn: '抱歉，没有搜索到任何符合的项目',
		default: '該当製品はありません。'
	};
	const dataFetchErrorMsgList = {
		en: 'Failed to retrieve product data.',
		cn: '检索产品数据失败。',
		default: '製品データの取得に失敗しました。'
	}
	const noResultsMsg = noResultsMsgList[basePath] || noResultsMsgList.default;
	const dataFetchErrorMsg = dataFetchErrorMsgList[basePath] || dataFetchErrorMsgList.default;


	// JSON取得 ===============================================
	// ニュースIDからカテゴリ取得する用
	const caseCategoryJson = `/${basePath}/ajax/products/casestudy/category/list.json`;
	const returnNew = (_id) => {
		return `/${basePath}/ajax/products/category/components/detail/new_icon_judgement/${_id}.json`;
	}
	// 大カテゴリ(A&D)
	const accessoriesSmallCategoryJson = (_category) => {
		return `/${basePath}/ajax/products/category/accessories/${_category}/list.json`;
	}
	// 中カテゴリ（コンポーネンツ）
	const componentsProductslistJson = (_word, _large, _middle, _param) => {
		return `/${basePath}/ajax/products/components/${_word}/${_large}/${_middle}/list.json?${_param}`;
	}
	// 小カテゴリ（紫外線除菌製品）
	const uvProductslistJson = (_middle, _small, _param) => {
		return `/${basePath}/ajax/products/uv-disinfection/${_middle}/${_small}/list.json?${_param}`;
	}
	// 製品詳細（A&D）
	const accessoriesRelationProductsJson = (_id, _type) => {
		return `/${basePath}/ajax/products/accessories/detail/related_products/${_id}/list.json?p_type=${_type}`;
	}
	// 大カテゴリ(深紫外)
	const uvSterilizationSmallCategoryJson = (_category) => {
		return `/${basePath}/ajax/products/category/uv-disinfection/${_category}/list.json`;
	}
	// <業界別ソリューション一覧>中カテゴリの公開可否を取得
	const returnMiddleCategoryStatus = (_smallCategory) => {
		return `/${basePath}/ajax/products/solution/category_m/judgement/${_smallCategory}.json`;
	}
	// <業界別ソリューション一覧>製品の公開可否を取得
	const returnProductsStatus = (_products) => {
		return `/${basePath}/ajax/products/solution/product/judgement/${_products}.json`;
	}
	// <業界別ソリューション一覧>小カテゴリの製品一覧取得
	const solutionSmallCategoryProducts = (_app, _category) => {
		return `/${basePath}/ajax/products/solution/${_app}/${_category}.json`;
	}
	// <業界別ソリューション一覧> 小カテゴリ、中カテゴリ、大カテゴリ判定
	const solutionSmallCategoryJudgement = (_category) => {
		return `/${basePath}/ajax/products/solution/category/class_judgement/${_category}.json`;
	}
	// <業界別ソリューション一覧> シリーズリンク判定
	const solutionSeriesLinkJudgement = (_app, _category) => {
		return `/${basePath}/products/solution/${_app}/${_category}/series_link_judgement.json`;
	}

	// <製品情報TOP> ===========================================
	// メインヴィジュアルスライド
	const mainSplide = () => {
		if (document.querySelector('.js-productsTop-main')) {
			let splide = new Splide('.js-productsTop-main.splide', {
				type: 'fade',
				rewind: true,
				perPage: 1,
				autoplay: true,
				interval: 5000,
				speed: 2000,
				arrows: false,
				pagination: false,
				paginationKeyboard: false,
				pauseOnHover: false,
			}).mount();
		}
	};
	// 製品検索
	const productsSearchForm = () => {
		// 製品TOP
		const searchForm = document.querySelector('.js-products-search');
		if (searchForm) {
			const select = searchForm.querySelector('.js-selectBox')
			const options = select.querySelectorAll('.mod-select02-list-option');
			const input = searchForm.querySelector('input[name="p_keyword"]');
			const exampleTxt = searchForm.querySelector('.js-products-search-ex');
			const head = searchForm.previousElementSibling;
			const defaultTxt = input.placeholder;
			const defaultTit = head.textContent;
			const defaultEx = exampleTxt.textContent;
			let accessoriesTxt = '品番・ガラス形状・タイプ・定格から探す';
			let accessoriesEx= 'R103　T10　12/5W';
			if (basePath === 'en') {
				accessoriesTxt = 'Product No./Glass Shape/Type/Rating';
			}
			let accessoriesTit = accessoriesTxt + 'から探す';
			if (basePath === 'en') {
				accessoriesTit = 'Search by ' + accessoriesTxt;
			}

			options.forEach(elem => {
				elem.addEventListener('click', (e) => {
					let thisVal = elem.getAttribute('data-value');
					if (thisVal === 'accessories') {
						head.textContent = accessoriesTit;
						input.placeholder = accessoriesTxt;
						exampleTxt.textContent = accessoriesEx;
					} else {
						head.textContent = defaultTit;
						input.placeholder = defaultTxt;
						exampleTxt.textContent = defaultEx;
					}
				})
			})
		}
		// 検索結果一覧
		const searchResultForm = document.querySelector('.js-products-search-result');
		if (searchResultForm) {
			const select = searchResultForm.querySelector('.js-selectBox')
			const options = select.querySelectorAll('.mod-select02-list-option');
			const resultH1 = document.querySelector('.js-search-h1');
			const selectedTxt = select.querySelector('.__selected');
			const defaultTit = resultH1.textContent;
			let accessoriesTxt = '品番 / ガラス形状 / タイプ / 定格から探す';
			if (basePath === 'en') {
				accessoriesTxt = 'Search by Product No./Glass Shape/Type/Rating';
			}

			// パラメータの値をセレクトボックスに反映
			const params = new URLSearchParams(location.search);
			const selectedCat = params.get('p_category_l');
			document.querySelector('.js-selectBox-input').value = selectedCat;


			// 自動車用電球・アクセサリーを選択したときのみ文言書き換え
			options.forEach(elem => {
				// 初期選択状態を設定
				if (elem.getAttribute('data-value') === selectedCat) {
					selectedTxt.textContent = elem.textContent;
					if (selectedCat === 'accessories') {
						resultH1.textContent = accessoriesTxt;
					}
				}

				elem.addEventListener('click', (e) => {
					let thisVal = elem.getAttribute('data-value');
					if (thisVal === 'accessories') {
						resultH1.textContent = accessoriesTxt;
					} else {
						resultH1.textContent = defaultTit;
					}
				})
			});
		}
	}
	// 関連情報・製品スライド
	const featureSplide = () => {
		if (document.querySelector('.js-productsTop-feature')) {
			let splide = new Splide('.js-productsTop-feature.splide', {
				// type: 'loop',
				perPage: 2,
				focus: 0,
				autoplay: false,
				interval: 5000,
				speed: 1000,
				arrows: true,
				pagination: true,
				// paginationKeyboard: true,
				destroy: true,
				breakpoints: {
					1025: {
						destroy: false,
						perPage: 1.2,
						gap: 16,
					}
				},
			}).mount();
		}
	};

	// <カテゴリTOP> ============================================
	// 大カテゴリ
	const largeCategoryTop = () => {
		const categoryBlock = document.querySelector('.js-lCategory-block');

		if (categoryBlock) {
			// 小カテゴリの説明文が20文字以上の場合省略
			const listItems = categoryBlock.querySelectorAll('li.__column_6.__column_tab_2.rt_bn_product_category_s');

			// listItems.forEach((item, index) => {
			// 	const desc = item.querySelector('.__txt');
			// 	if (desc) {
			// 		if (desc.textContent.length > 20) {
			// 			desc.textContent = desc.textContent.slice(0, 20) + '...';
			// 		}
			// 	}
			// })


			window.addEventListener('DOMContentLoaded', async () => {
				// h2周りのテンプレート
				let componentsHead = await fetch('/common/js/html/products-components-head.html').then(res => res.text());
				// TABLET/SP用の一覧リンクのテンプレート
				let componentsLink = await fetch('/common/js/html/products-components-link.html').then(res => res.text());

				let previousCategory = '';
				let previousCategoryLink = '';
				let previousCategoryCode = '';

				// const listItems = document.querySelectorAll('li.__column_6.__column_tab_2.rt_bn_product_category_s');

				// セクション
				let newSection = document.createElement('section');
				newSection.classList.add('mod-spacer-section');
				// ul
				let newUl = document.createElement('ul');
				newUl.classList.add('mod-column');
				let headHtml = '';
				let linkHtml = '';
				let allHtml = '';
				let listTxt = '一覧へ';
				if (basePath === 'en') {
					listTxt = ' List';
				} else if (basePath === 'cn') {
					listTxt = '列表';
				}

				listItems.forEach((item, index) => {
					// カテゴリ名の取得
					const category = item.querySelector('span.rt_cf_pcs_category_m_name').textContent.trim();
					// カテゴリリンクの取得
					const categoryLink = item.querySelector('span.rt_cf_pcs_category_m_href').textContent.trim();
					const categoryCode = categoryLink.split('/')[categoryLink.split('/').length - 2];

					// 現在のカテゴリ名と前回のカテゴリ名が異なる場合
					if (category !== previousCategory && index !== 0) {
						headHtml = componentsHead
							.replaceAll('{!href!}', previousCategoryLink)
							.replaceAll('{!category!}', previousCategory)
							.replaceAll('{!categoryList!}', previousCategory + listTxt);
						linkHtml = componentsLink
							.replaceAll('{!href!}', previousCategoryLink)
							.replaceAll('{!categoryList!}', previousCategory + listTxt);

						// sectionを親要素に追加
						newSection.setAttribute('id', previousCategoryCode);
						newSection.insertAdjacentHTML('beforeend', headHtml);
						newSection.appendChild(newUl);
						newSection.insertAdjacentHTML('beforeend', linkHtml);
						allHtml += newSection.outerHTML;

						// 新しいsectionを作成
						newSection = document.createElement('section');
						newSection.setAttribute('id', categoryCode);
						newSection.classList.add('mod-spacer-section');
						headHtml = componentsHead
							.replaceAll('{!href!}', categoryLink)
							.replaceAll('{!category!}', category)
							.replaceAll('{!categoryList!}', category + listTxt);
						linkHtml = componentsLink
							.replaceAll('{!href!}', categoryLink)
							.replaceAll('{!categoryList!}', category + listTxt);
						newUl = document.createElement('ul');
						newUl.classList.add('mod-column');
					}

					// 現在のliを新しいulに追加
					const clonedItem = item.cloneNode(true); // 元の要素をコピー
					newUl.appendChild(clonedItem);

					// 前回のカテゴリ名を更新
					previousCategory = category;
					previousCategoryLink = categoryLink;
					previousCategoryCode = categoryCode;
				});

				// 最後のセクションを追加
				newSection.appendChild(newUl);
				newSection.insertAdjacentHTML('afterbegin', headHtml);
				newSection.insertAdjacentHTML('beforeend', linkHtml);
				allHtml += newSection.outerHTML;
				categoryBlock.innerHTML = allHtml;
			});
		}
	}

	// 中カテゴリ（コンポーネンツ）製品一覧出力
	const createProductsTable = async () => {
		const output = document.querySelector('#app1'); // コンポーネンツand紫外線除菌
		const appOutput = document.querySelectorAll('.js-app-block'); // 業界別ソリューション一覧
		if (output || appOutput.length) {
			const lCategory = $path.split('/')[$path.split('/').length - 3];
			const mCategory = $path.split('/')[$path.split('/').length - 2];
			const urlParams = new URLSearchParams(window.location.search);

			urlParams.forEach((value, key) => {
				let parsedKey = key;
				if (!$path.includes('/products/category/uv-disinfection/')) {
					if (/^(dominant|intensity|flux|current|voltage)_(1|2|3)$/.test(key)) {
						const [k, kIdx] = key.split('_');
						parsedKey = k;
					}
				}

				if (/^angle_(1|2|3)(x|y)$/.test(key)) {
					const [k, kIdxXY] = key.split('_');
					const [kIdx, kXY] = kIdxXY.split('');
					parsedKey = k + '_' + kXY;
				}

				const minInput = document.querySelector(`[name="${parsedKey}_min"]`);
				const maxInput = document.querySelector(`[name="${parsedKey}_max"]`);
				const step = maxInput?.getAttribute('data-step') ?? 0;


				// min 1  max 1.1  step 0.1    1_1.2

				if (value.includes('_') && minInput && maxInput) {
					const [left, right] = value.split('_');
					const maxValue = right === '' ? '' : Number(right) + Number(step);
					const minValue = Number(left);

					urlParams.set(key, `${minValue}_${maxValue}`);
				}
			})
			let jsonWords = lCategory;

			// コンポーネンツ
			if (lCategory === 'visible-light') {
				if (mCategory === 'ambientlight') {
					jsonWords = 'ambientlight';
				} else {
					jsonWords = 'not_ambientlight';
				}
			} else if (lCategory === 'ultraviolet-light') {
				if (mCategory === 'uv-ccl') {
					jsonWords = 'uv_ccl';
				} else {
					jsonWords = 'ultraviolet';
				}
			} else if (lCategory === 'infrared-light') {
				if (mCategory === 'infrared-led') {
					jsonWords = 'infrared_led';
					// サイドメニューの文言出し分け
					const menuTxt = document.querySelectorAll('.js-searchMenu-txt');
					menuTxt.forEach(ele => {
						if (ele.classList.contains('infrared-led')) {
							ele.classList.remove('di_none');
						} else {
							ele.classList.add('di_none');
						}
					});
				} else {
					jsonWords = 'vcsel';
				}
			}

			// 桁数を4桁から3桁に縮める処理における除外製品
			const excludedProducts = ["VCTW1152GDS"];

			// コンポーネンツand紫外線除菌
			let jsonUrl = $path.includes('/category/uv-disinfection/') ? uvProductslistJson(lCategory, mCategory, urlParams) : componentsProductslistJson(jsonWords, lCategory, mCategory, urlParams);

			const createTbl = (_elem, _category) => {
				document.querySelector(_elem).classList.remove('di_none');

				new Vue({
					el: _elem,
					data() {
						return {
							products: [],
							filteredItems: [],
							sortedProducts: [],
							showSortBox: false,
							displayedCount: 20, // 20件ずつ表示
							visibleCount: 20, // is-visibleクラスが付く件数
							showAll: true,
							showChecked: false, // チェックされた製品のみ表示するフラグ
							checkedProducts: [], // チェックされた製品
							lastSortKey: '', // 最後に使用したソートキー
							lastSortOrder: 'asc', // 最後に使用したソート順
							activeSortKey: null,      // 'cf_p_number_asc' など
							activeSortColumn: null,   // 'cf_p_number' など
						};
					},
					created() {
						this.fetchProducts();
					},
					computed: {
						filteredTags() {
							return this.products.map(product => {
								// 空のcf_p_tagsを持つ製品を除外し、nullでないタグのみを返す
								return product.cf_p_tags ? product.cf_p_tags.filter(tag => tag.rt_cf_p_tags_components_list !== null) : [];
							});
						},
						displayedProducts() {
							// チェックされた製品のみを表示する場合
							if (this.showChecked) {
								return this.checkedProducts;
							}
							// 全製品を表示する場合、ただしis-visibleクラスの有無を考慮
							return this.sortedProducts.map((product, index) => {
								// is-visibleクラスを設定（初期表示の20件）
								product.isVisible = index < this.visibleCount;
								return product;
							});
						},
						shouldShowMoreButton() {
							// 初期状態で20件以上ある場合、もっと見るボタンを表示する
							return !this.showChecked && this.sortedProducts.length > this.visibleCount;
						},
						isInfraredLED() {
							if(window.location.href.includes('/products/solution/')) {
								if(_category === 'infrared-high' || _category === 'infrared-low') {
									return true;
								}
							} else {
								return typeof window !== 'undefined' && window.location.href.includes('/products/category/infrared-light/infrared-led/');
							}
						},
						isUnitChangeCategory() {// 反射センサー
							return typeof window !== 'undefined' && (window.location.href.includes('/products/category/sensor/reflective_sensor/') || window.location.href.includes('/products/category/sensor/photodiode/'));
						}
					},
					methods: {
						fetchProducts() {
							axios.get(jsonUrl)
								.then(response => {
									const productData = _elem.includes('solution')
										? response.data.rt_bn_app_product_list
										: response.data.rt_bn_product;
									
									// 各製品にisVisible属性を追加
									productData.forEach((product, index) => {
										// 最初の20件のみis-visible = trueにする
										product.isVisible = index < this.visibleCount;
									});
									
									this.products = productData;
									this.originalProducts = [...productData];  // ディープコピーで初期データを保存
									this.sortedProducts = productData;         // 初期表示用データ
								})
								// 読み込み完了後
								.then(() => {
									this.$nextTick(() => {
										// 初期表示時に最初の20件にis-visibleクラスを追加
										this.applyVisibleClassToDOM();
										
										// コンポーネンツ
										let tblWrap = document.querySelectorAll('.js-componentsTbl');
										if (tblWrap.length > 0) {
											tblWrap.forEach(ele => {
												if (!ele.classList.contains('di_none')) {
													ele.classList.add('is-loaded');
													let resultText = ele.querySelector('.products-cat-body-results');
													resultText.classList.remove('di_none');
													if (this.products.length === 0) {
														ele.querySelector('.products-cat-body').insertAdjacentHTML('afterend', `<p class="products-cat-tbl-msg">${noResultsMsg}</p>`);
													}
												}
											})
										}
										// 深紫外製品(UV製品)
										let uvTbl = document.querySelectorAll('.js-uvTbl');
										if (uvTbl.length) {
											uvTbl.forEach(ele => {
												if (!ele.classList.contains('di_none')) {
													ele.classList.add('is-loaded');
													let resultText = ele.querySelector('.products-cat-body-results');
													resultText.classList.remove('di_none');
													if (this.products.length === 0) {
														ele.insertAdjacentHTML('afterend', `<p class="products-cat-tbl-msg">${noResultsMsg}</p>`);
													}
												}
											})
										}
										// 業界別ソリューション一覧
										let appTbl = document.querySelectorAll('.js-app-block');
										if (appTbl.length) {
											appTbl.forEach(ele => {
												ele.classList.add('is-loaded');
												let resultText = ele.querySelectorAll('.products-cat-body-results');
												resultText.forEach(ele => {
													ele.classList.remove('di_none');
												});
												if (this.products.length === 0) {
													ele.insertAdjacentHTML('afterend', `<p class="products-cat-tbl-msg">${noResultsMsg}</p>`);
												}
											})
										}
									});
								})
								.then(() => {
									scrollTable();
								})
								.catch(error => {
									console.error("製品データの取得に失敗しました", error);
									// コンポーネンツ
									let tblWrap = document.querySelectorAll('.js-componentsTbl');
									if (tblWrap.length > 0) {
										tblWrap.forEach(ele => {
											if (!ele.classList.contains('di_none')) {
												ele.classList.add('is-loaded');
												if (this.products.length === 0) {
													ele.querySelector('.products-cat-body').insertAdjacentHTML('afterend', `<p class="products-cat-tbl-msg">${dataFetchErrorMsg}</p>`);
												}
											}
										})
									}
									// 深紫外製品(UV製品)
									let uvTbl = document.querySelectorAll('.js-uvTbl');
									if (uvTbl.length) {
										uvTbl.forEach(ele => {
											if (!ele.classList.contains('di_none')) {
												ele.classList.add('is-loaded');
												if (this.products.length === 0) {
													ele.insertAdjacentHTML('afterend', `<p class="products-cat-tbl-msg">${dataFetchErrorMsg}</p>`);
												}
											}
										})
									}
									// 業界別ソリューション一覧
									let appTbl = document.querySelectorAll('.js-app-block');
									if (appTbl.length) {
										appTbl.forEach(ele => {
											ele.classList.add('is-loaded');
											if (this.products.length === 0) {
												ele.insertAdjacentHTML('afterend', `<p class="products-cat-tbl-msg">${dataFetchErrorMsg}</p>`);
											}
										})
									}
								});
						},
						// 実際のDOMに対してis-visibleクラスを適用するための新しいメソッド
						applyVisibleClassToDOM() {
							// テーブルのtr要素を取得
							const tableRows = document.querySelectorAll(`${_elem} tbody tr`);
							
							// 最初の20件にクラスを追加
							tableRows.forEach((row, index) => {
								if (index < this.visibleCount) {
									row.classList.add('is-visible');
								} else {
									row.classList.remove('is-visible');
								}
							});
						},
						filterItems() {
							if (this.showComparison) {
								this.filteredItems = this.products.filter(item => item.comparison);
							} else {
								this.filteredItems = this.products;
							}
						},
						resetItems() {
							this.filteredItems = []; // リセット時にフィルタリングされたアイテムをクリア
							this.showComparison = false; // チェックボックスもリセット
						},
						toggleSortBox(event) {
							this.showSortBox = !this.showSortBox;
						},
						sortProducts(key, order) {
							this.visibleReset();
							
							// ソートボックスを非表示
							this.showSortBox = !this.showSortBox;

							const active = document.activeElement;
							const parentsTbl = active.closest('.js-sortTable');
							const button = parentsTbl.querySelector('.js-sorBox-btn')
							button.classList.add('is-active');

							// ソートボタンにis-activeをtoggleする
							const buttons = parentsTbl.querySelectorAll('.mod-link03')
    						buttons.forEach(btn => btn.classList.remove('is-active'));
							if (active && active.classList.contains('mod-link03')) {
								active.classList.add('is-active');
							}

							// ソートキーと順序を保存
							this.lastSortKey = key;
							this.lastSortOrder = order;

							// <th> の is-active / asc / desc を管理
							const allThs = parentsTbl.querySelectorAll('th');
							allThs.forEach(th => {
								th.classList.remove('is-active', 'asc', 'desc');
							});

							// 対応する <th> を選択してクラスを追加
							const targetTh = parentsTbl.querySelectorAll(`.th-${key}`);
							if (targetTh) {
								targetTh.forEach(th => {
									th.classList.add('is-active', order);
								})
							}

							if (this.showChecked) {
								// チェックされた製品に対してソート
								this.checkedProducts = [...this.checkedProducts].sort((a, b) => {
									const aValue = a[key] != null ? a[key] : '';
									const bValue = b[key] != null ? b[key] : '';

									// 数値の場合は数値として比較、文字列の場合はlocaleCompareを使用
									const aNum = Number(aValue);
									const bNum = Number(bValue);

									// 数値として比較
									if (!isNaN(aNum) && !isNaN(bNum)) {
										return order === 'asc' ? aNum - bNum : bNum - aNum;
									}

									// 文字列として比較
									return order === 'asc'
										? aValue.localeCompare(bValue)
										: bValue.localeCompare(aValue);
								});
							} else {
								// 全製品に対してソート
								this.sortedProducts = [...this.sortedProducts].sort((a, b) => {
									const aValue = a[key] != null ? a[key] : '';
									const bValue = b[key] != null ? b[key] : '';

									// 数値の場合は数値として比較、文字列の場合はlocaleCompareを使用
									const aNum = Number(aValue);
									const bNum = Number(bValue);

									// 数値として比較
									if (!isNaN(aNum) && !isNaN(bNum)) {
										return order === 'asc' ? aNum - bNum : bNum - aNum;
									}

									// 文字列として比較
									return order === 'asc'
										? aValue.localeCompare(bValue)
										: bValue.localeCompare(aValue);
								});
								
								// ソート後に可視性を更新
								this.updateVisibleProducts();
								
								// DOM要素にも反映
								this.$nextTick(() => {
									this.applyVisibleClassToDOM();
								});
							}
						},
						minValue(product, keys) {
							try {
								const values = keys.map(key => Number(product[key] || Infinity));
								return values.length ? Math.min(...values) : Infinity;
							} catch (error) {
								console.error("Error in minValue:", error);
								return Infinity;
							}
						},
						maxValue(product, keys) {
							try {
								const values = keys.map(key => Number(product[key] || -Infinity));
								return values.length ? Math.max(...values) : -Infinity;
							} catch (error) {
								console.error("Error in maxValue:", error);
								return -Infinity;
							}
						},
						sortByMin(keys, order) {
							this.visibleReset();

							// ソートボックスを非表示
							this.showSortBox = !this.showSortBox;

							const active = document.activeElement;
							const parentsTbl = active.closest('.js-sortTable');
							const button = parentsTbl.querySelector('.js-sorBox-btn')
							button.classList.add('is-active');

							const getMinValue = (product) => {
								const validKeys = keys.filter(key => product[key] != null).map(key => Number(product[key]));
								return validKeys.length > 0 ? Math.min(...validKeys) : (order === 'asc' ? Infinity : -Infinity);
							};

							this.sortedProducts = [...this.products].sort((a, b) => {
								const minA = getMinValue(a);
								const minB = getMinValue(b);
								return order === 'asc' ? minA - minB : minB - minA;
							});

							this.updateVisibleProducts();
							this.$nextTick(() => {
								this.applyVisibleClassToDOM();
							});

							// ソートボタンのクラスをtoggleする
							const buttons = parentsTbl.querySelectorAll('.mod-link03')
    						buttons.forEach(btn => btn.classList.remove('is-active'));
							if (active && active.classList.contains('mod-link03')) {
								active.classList.add('is-active');
							}

							// <th> の is-active / asc / desc を管理
							const allThs = parentsTbl.querySelectorAll('th');
							allThs.forEach(th => {
								th.classList.remove('is-active', 'asc', 'desc');
							});

							// 対応する <th> を選択してクラスを追加
							console.log('keys',keys)
							const targetTh = parentsTbl.querySelectorAll(`.th-${keys[0]}`);
							if (targetTh) {
								targetTh.forEach(th => {
									th.classList.add('is-active', order);
								})
							}
						},
						sortByMax(keys, order) {
							this.visibleReset();

							// ソートボックスを非表示
							this.showSortBox = !this.showSortBox;
							
							const active = document.activeElement;
							const parentsTbl = active.closest('.js-sortTable');
							const button = parentsTbl.querySelector('.js-sorBox-btn')
							button.classList.add('is-active');

							const getMaxValue = (product) => {
								const validKeys = keys.filter(key => product[key] != null).map(key => Number(product[key]));
								return validKeys.length > 0 ? Math.max(...validKeys) : (order === 'asc' ? -Infinity : Infinity);
							};

							this.sortedProducts = [...this.products].sort((a, b) => {
								const maxA = getMaxValue(a);
								const maxB = getMaxValue(b);
								return order === 'asc' ? maxA - maxB : maxB - maxA;
							});

							this.$nextTick(() => {
								this.applyVisibleClassToDOM();
							});

							// ソートボタンのクラスをtoggleする
							const buttons = parentsTbl.querySelectorAll('.mod-link03')
    						buttons.forEach(btn => btn.classList.remove('is-active'));
							if (active && active.classList.contains('mod-link03')) {
								active.classList.add('is-active');
							}

							// <th> の is-active / asc / desc を管理
							const allThs = parentsTbl.querySelectorAll('th');
							allThs.forEach(th => {
								th.classList.remove('is-active', 'asc', 'desc');
							});

							// 対応する <th> を選択してクラスを追加
							const targetTh = parentsTbl.querySelectorAll(`.th-${keys[0]}`);
							if (targetTh) {
								targetTh.forEach(th => {
									th.classList.add('is-active', order);
								})
							}
						},
						resetProducts() {
							this.visibleReset();

							// ソートボックスを非表示
							this.showSortBox = !this.showSortBox;
							const active = document.activeElement;
							const parentsTbl = active.closest('.js-sortTable');
							const button = parentsTbl.querySelector('.js-sorBox-btn')
							button.classList.remove('is-active');

							// 初期表示のデータに戻す
							this.sortedProducts = [...this.originalProducts];
							
							// DOM要素にも反映
							this.$nextTick(() => {
								this.applyVisibleClassToDOM();
							});

							// ソートボタンのis-activeクラスをリセット
							const buttons = parentsTbl.querySelectorAll('.mod-link03')
    						buttons.forEach(btn => btn.classList.remove('is-active'));

							// <th> の is-active / asc / desc を管理
							const allThs = parentsTbl.querySelectorAll('th');
							allThs.forEach(th => {
								th.classList.remove('is-active', 'asc', 'desc');
							});
						},
						setShowChecked() {
							// チェックされた製品があるか確認
							const hasCheckedProducts = this.products.some(product => product.checked);
							if (hasCheckedProducts) {
								this.checkedProducts = this.sortedProducts.filter(product => product.checked);
								this.showChecked = true; // チェックされた製品のみを表示

								// 最後に使用したソートキーと順序で再ソート
								if (this.lastSortKey && this.lastSortOrder) {
									this.sortProducts(this.lastSortKey, this.lastSortOrder);
								}
							} else {
								this.checkedProducts = [];
								this.showChecked = false;
							}
						},
						reset() {
							// チェックされた製品が一つでもあるか確認
							let hasCheckedProducts = this.products.some(product => product.checked);
							if (hasCheckedProducts) {
								this.displayedCount = 20; // 初期表示に戻す
								this.showAll = true; // 全て表示
								this.showChecked = false;
								this.products.forEach(product => {
									product.checked = false; // チェックボックスをリセット
								});
							}
						},
						updateVisibleProducts() {
							// 初期表示の最初のvisibleCount件にis-visibleクラスを設定
							this.sortedProducts.forEach((product, index) => {
								product.isVisible = index < this.visibleCount;
							});
						},
						showMore() {
							// 「もっと見る」ボタン
							// 次の20件を表示するためにカウントを増やす
							this.visibleCount += 20;
							
							// 表示状態を更新
							this.sortedProducts.forEach((product, index) => {
								if (index < this.visibleCount) {
									product.isVisible = true;
								}
							});
							
							// DOM要素にも反映
							this.$nextTick(() => {
								this.applyVisibleClassToDOM();
							});
						},
						visibleReset() {
							// 表示リセット
							this.visibleCount = 20;
							this.updateVisibleProducts();
						},
						// 「開発品」や「廃止予定品」が含まれていないかチェックする関数
						hasNoDevOrDiscontinuedTag(product) {
							if (product.cf_p_tags && product.cf_p_tags.some(tag => {
								const tagContent = tag.rt_cf_p_tags_components_list?.content;
								return tagContent === "開発品" || tagContent === "廃止予定品";
							})) {
								return false; // "開発品" または "廃止予定品" があった場合
							} else {
								return true; // どちらもない場合
							}							
						},
						// NEWアイコンを表示するかどうかの判定
						showNewIcon(product) {
							if ($path.includes('/uv-disinfection/')) {
								return product.rt_cf_p_new_icon !== null;
							} else {
								return product.rt_cf_p_new_icon !== null && this.hasNoDevOrDiscontinuedTag(product);
							}
						},
						// 空のオブジェクトかどうかを判定する関数
						isNotEmptyObject(obj) {
							return obj && Object.keys(obj).length !== null;
						},
						// \nを<br>に変換
						formatTextWithBr(text) {
							if (!text) return '';
							return text.replace(/\n/g, '<br>');
						},
						formattedChromaticity(_product, _chromaticity) {
							// `_product` が `null` や `undefined` の場合はそのまま値を返す
							if (!_product) return _chromaticity;

							// 商品のカテゴリキーを取得（デフォルト値を設定して安全に処理）
							const categoryKey = _product?.cf_p_category_s?.rt_cf_p_category_s_key?.content || "";
							const productsKey = _product?.cf_p_number || "";

							// キーが特定の値のときのみ、小数点3桁に丸める
							const validKeys = ["ac", "1c", "4r", "8l", "2g", "5g", "bua", "tri-color", "4l"];
							if (validKeys.includes(categoryKey) && _chromaticity !== null && !excludedProducts.includes(productsKey)) {
								return (Math.floor(_chromaticity * 1000) / 1000).toFixed(3); // 小数点3桁に固定
							}

							// 条件に合わない場合、そのままの値を返す
							return _chromaticity;
						},
						// <センサー/フォトトランジスター>小数点を第一位までに丸める
						formattedSensor1(_product, _name,  _data) {
							// `_product` が `null` や `undefined` の場合はそのまま値を返す
							if (!_product) return _data;

							// 商品のカテゴリキーを取得（デフォルト値を設定して安全に処理）
							const categoryKey = location.pathname.split('/')[5];
							if (categoryKey === 'phototransistor' &&  _data !== null) {
								return (Math.floor(_data * 1000) / 1000).toFixed(1); // 小数点1桁に固定
							} else if (categoryKey === 'reflective_sensor') {
								//　反射センサー
								if(_data !== null && _name.includes('cf_p_dark_current')) {
									// 暗電流
									return (Math.floor(_data * 1000) / 1000).toFixed(1); // 小数点1桁に固定
								} else {
									// 光電流、	立ち上がり時間、立ち下がり時間
									return (Math.floor(_data * 1000) / 1000).toFixed(0); // 小数点0桁に固定
								}
							} else if (categoryKey === 'photodiode' &&  _data !== null) {
								// フォトダイオード
								// 光電流のみ
								if(_data !== null && _name.includes('cf_p_photocurrent')) {
									return (Math.floor(_data * 1000) / 1000).toFixed(0); // 小数点0桁に固定
								}
							}
							// 条件に合わない場合、そのままの値を返す
							return _data;
						}
					},
				})

			};

			if ($path.includes('/category/uv-disinfection/')) {
				// 紫外線除菌製品
				if ($path.includes('/uvcled_reactor/')) {
					// 深紫外製品(UV製品):UV-C LED リアクター
					createTbl('#app1');
				} else if ($path.includes('/uvcled_disinfection/')) {
					// 深紫外製品(UV製品):UV-C LED 除菌装置
					createTbl('#app2');
				} else {
					// 深紫外製品(UV製品):UV-CCL リアクター
					createTbl('#app3');
				}
			} else if ($path.includes('/category/')) {
				// 可視光源・紫外光源・赤外光源・センサ
				if ($path.includes('/visible-light/')) {
					if ($path.includes('/ambientlight/')) {
						// 可視光源（アンビエントライト）start
						createTbl('#app2');
					} else {
						// 可視光源（アンビエントライト以外）start
						createTbl('#app1');
					}
				} else if ($path.includes('/ultraviolet-light/') || $path.includes('/infrared-light/infrared-led/')) {
					if ($path.includes('/uv-ccl/')) {
						// 冷陰極型UVランプ (UV-CCL)
						createTbl('#app6');
					} else {
						// 紫外光源（近紫外・深紫外共通）／赤外光源/赤外LED
						createTbl('#app3');
					}
				} else if ($path.includes('/infrared-light/vcsel/')) {
					// 赤外光源/赤外VCSEL
					createTbl('#app4');
				} else {
					// センサ
					createTbl('#app5');
				}
			} else {
				// 業界別ソリューション一覧
				if (appOutput.length) {
					const appCode = $path.split('/')[$path.split('/').length - 2];
					appOutput.forEach(elem => {
						let headEml = elem.querySelector('.mod-head03');
						if (headEml) {
							let catCode = headEml.getAttribute('id');
							const thisId = 'solution-' + catCode;
							elem.setAttribute('id', thisId);
							// jsonUrlを取得
							jsonUrl = solutionSmallCategoryProducts(appCode, catCode);
							createTbl('#' + thisId, catCode);
						}
					});
					// テーブル表示／非表示
					appCategoryHidden();
				}
			}

			sortTable();
		}
	}
	// 中カテゴリ（コンポーネンツ）／紫外線除菌製品　選択項目の表示
	const selectedItems = () => {
		const output = document.querySelector('.js-searchMenu-selected');
		const outputList = document.querySelector('.js-searchMenu-selected-list');
		const urlObj = new URL(location.href);
		const urlParams = new URLSearchParams(urlObj.search);
		const searchMenu = document.querySelector('.js-productsMenu');
		let param = location.search.slice(1);
		let paramArr = param.split('&');

		// 桁数に基づいて-1(-0.1、-0.01・・・)
		const adjustMaxValue = (maxValue) => {
			// 小数点以下の桁数を取得
			// let decimalPlaces = (maxValue % 1 === 0) ? 0 : maxValue.toString().split('.')[1].length;
			// // 加算する値を動的に決定 (10のマイナス乗)
			// let increment = Math.pow(10, -decimalPlaces);
			// // maxValue に適切な値を加算
			// return Number(maxValue) - increment;
			return maxValue;
		}

		const matchFloat = (value1, value2) => {
			const value1Number = Number(value1)
			const value2Number = Number(value2)
			if (value1 != "" && value2 != "" && !isNaN(value1Number) && !isNaN(value2Number)) {
				if (`${value1}`.includes('.') || `${value2}`.includes('.')) {
					const value1DecimalKeta = value1.split('.')[1] ? value1.split('.')[1].length : 0;
					const value2DecimalKeta = value2.split('.')[1] ? value2.split('.')[1].length : 0;
					const maxKeta = Math.max(value1DecimalKeta, value2DecimalKeta);
					return [value1Number.toFixed(maxKeta), value2Number.toFixed(maxKeta)];
				}
			}
			return [value1, value2];
		}

		// NEWのvalueに「180日前_」を設定する
		if (searchMenu) {
			const newInput = searchMenu.querySelector('input[name="new"]');

			const getDate180DaysAgo = () => {
				const currentDate = new Date();
				// 180日前
				currentDate.setDate(currentDate.getDate() - 180);
				const year = currentDate.getFullYear();
				const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月は0から始まるので+1
				const day = String(currentDate.getDate()).padStart(2, '0'); // 2桁になるようにゼロ埋め
				return `${year}${month}${day}`;
			}

			const date180DaysAgo = getDate180DaysAgo();
			newInput.value = date180DaysAgo + '_';
		}

		if (output) {

			if (paramArr.length > 0 && paramArr.every(item => item !== '' && item !== null && item !== undefined)) {
				paramArr.forEach(ele => {
					let addItem = '';
					let thisName = ele.split('=')[0];
					let thisValue = decodeURIComponent(ele.split('=')[1].replace(/\+/g, ' '));
					let thisItemInput = searchMenu.querySelector('input[name="' + thisName + '"]');
					let thisItemInputType = 'checkbox';
					if (!thisItemInput) {
						thisItemInputType = 'text';
					}
					let thisItem = searchMenu.querySelector('input[name="' + thisName + '"][value="' + thisValue + '"]');
					if (thisItem) {
						thisItem.checked = true;
					}

					if (thisItemInputType === 'text') {

						if (thisName.includes('_x')) {
							let thisMinInput = searchMenu.querySelector('input[name="' + thisName + '_min"]');
							let thisMaxInput = searchMenu.querySelector('input[name="' + thisName + '_max"]');
							let thisMin = thisValue.split('_')[0];
							let thisMax = adjustMaxValue(thisValue.split('_')[1]);
							[thisMin, thisMax] = matchFloat(thisMin, thisMax);
							thisMinInput.value = thisMin;
							thisMaxInput.value = thisMax;
							// 単位を取得
							let parentElement = thisMinInput.closest('.products-searchMenu-item-toggle');
							let previousItem = parentElement ? parentElement.previousElementSibling : null;
							let buttonText = previousItem && previousItem.classList.contains('products-searchMenu-item')
								? previousItem.textContent.trim()
								: '';
							// 単位込みで「選択項目があります」欄に反映
							addItem = '<li><button type="button" data-name="' + thisName + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>' + buttonText + ' X:' + thisMin + '～' + thisMax + '</button></li>';
						} else if (thisName.includes('_y')) {
							let thisMinInput = searchMenu.querySelector('input[name="' + thisName + '_min"]');
							let thisMaxInput = searchMenu.querySelector('input[name="' + thisName + '_max"]');
							let thisMin = thisValue.split('_')[0];
							let thisMax = adjustMaxValue(thisValue.split('_')[1]);
							[thisMin, thisMax] = matchFloat(thisMin, thisMax);
							thisMinInput.value = thisMin;
							thisMaxInput.value = thisMax;
							// 単位を取得
							let parentElement = thisMinInput.closest('.products-searchMenu-item-toggle');
							let previousItem = parentElement ? parentElement.previousElementSibling : null;
							let buttonText = previousItem && previousItem.classList.contains('products-searchMenu-item')
								? previousItem.textContent.trim()
								: '';
							// 単位込みで「選択項目があります」欄に反映
							addItem = '<li><button type="button" data-name="' + thisName + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>' + buttonText + ' Y:' + thisMin + '～' + thisMax + '</button></li>';
						} else if (thisName.includes('angle_1x')) {
							// 指向半値角(x)
							let thisMinInput = searchMenu.querySelector('input[name="angle_x_min"]');
							let thisMaxInput = searchMenu.querySelector('input[name="angle_x_max"]');
							let thisMin = thisValue.split('_')[0];
							let thisMax = adjustMaxValue(thisValue.split('_')[1]);
							[thisMin, thisMax] = matchFloat(thisMin, thisMax);
							thisMinInput.value = thisMin;
							thisMaxInput.value = thisMax;
							// 単位を取得
							let parentElement = thisMinInput.closest('.products-searchMenu-item-toggle');
							let previousItem = parentElement ? parentElement.previousElementSibling : null;
							let buttonText = previousItem && previousItem.classList.contains('products-searchMenu-item')
								? previousItem.textContent.trim()
								: '';
							// 単位込みで「選択項目があります」欄に反映
							addItem = '<li><button type="button" data-name="' + thisName.replace('1', '') + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>' + buttonText + ' X:' + thisMin + '～' + thisMax + '</button></li>';
						} else if (thisName.includes('angle_1y')) {
							// 指向半値角(y)
							let thisMinInput = searchMenu.querySelector('input[name="angle_y_min"]');
							let thisMaxInput = searchMenu.querySelector('input[name="angle_y_max"]');
							let thisMin = thisValue.split('_')[0];
							let thisMax = adjustMaxValue(thisValue.split('_')[1]);
							[thisMin, thisMax] = matchFloat(thisMin, thisMax);
							thisMinInput.value = thisMin;
							thisMaxInput.value = thisMax;
							// 単位を取得
							let parentElement = thisMinInput.closest('.products-searchMenu-item-toggle');
							let previousItem = parentElement ? parentElement.previousElementSibling : null;
							let buttonText = previousItem && previousItem.classList.contains('products-searchMenu-item')
								? previousItem.textContent.trim()
								: '';
							// 単位込みで「選択項目があります」欄に反映
							addItem = '<li><button type="button" data-name="' + thisName.replace('1', '') + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>' + buttonText + ' Y:' + thisMin + '～' + thisMax + '</button></li>';
						} else {
							if (!$path.includes('/products/category/uv-disinfection/')) {
								// 紫外線除菌製品以外
								thisName = thisName.replace(/_\d+$/, '');
							}

							let thisMinInput = searchMenu.querySelector('input[name="' + thisName + '_min"]');
							let thisMaxInput = searchMenu.querySelector('input[name="' + thisName + '_max"]');
							if (thisMinInput) {
								let thisMin = thisValue.split('_')[0];
								let thisMax = adjustMaxValue(thisValue.split('_')[1]);
								[thisMin, thisMax] = matchFloat(thisMin, thisMax);
								thisMinInput.value = thisMin;
								thisMaxInput.value = thisMax;

								// 単位を取得
								let parentElement = thisMinInput.closest('.products-searchMenu-item-toggle');
								let previousItem = parentElement ? parentElement.previousElementSibling : null;
								let buttonText = previousItem && previousItem.classList.contains('products-searchMenu-item')
									? previousItem.textContent.trim()
									: '';
								let unitText = parentElement ? parentElement.querySelector('.__unit').textContent : '';
								// 単位込みで「選択項目があります」欄に反映
								addItem = '<li><button type="button" data-name="' + thisName + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>' + buttonText + ':' + thisMin + '～' + thisMax + unitText + '</button></li>';
							}
						}
					} else {
						if (searchMenu.querySelectorAll('input[name="' + thisName + '"]').length) {
							// thisItem = searchMenu.querySelector('input[name="'+ thisName +'"]');
							// 「選択項目があります」欄に反映
							if (thisName === 'new') {
								// NEW
								addItem = '<li><button type="button" data-name="' + thisName + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>NEW</button></li>'
							} else {
								// その他
								let thisTxt = '';
								// thisItemInputType
								if (thisItemInput.getAttribute('type') === 'checkbox') {
									// チェックボックスの場合
									thisTxt = thisItem.nextElementSibling.textContent;
								} else {
									// textインプットの場合
									thisItemInput.value = thisValue;
									let parentElement = thisItemInput.closest('.products-searchMenu-item-toggle');
									let previousItem = parentElement ? parentElement.previousElementSibling : null;
									let buttonText = previousItem && previousItem.classList.contains('products-searchMenu-item') ? previousItem.textContent.trim() : '';
									let unitText = parentElement.querySelector('.__unit') ? parentElement.querySelector('.__unit').textContent : '';
									thisTxt = buttonText + ':' + thisValue + unitText;
								}
								addItem = '<li><button type="button" data-name="' + thisName + '" data-value="' + thisValue + '" class="js-itemRemove"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#close2"></use></svg>' + thisTxt + '</button></li>'
							}
						} else {
							return false;
						}
					}

					if (thisValue !== '' && !outputList.innerHTML.includes(addItem)) {
						outputList.insertAdjacentHTML('beforeend', addItem);
						output.classList.remove('di_none');
					}
				});

				// タグをクリックして削除
				const outputListItem = document.querySelectorAll('.js-itemRemove');
				outputListItem.forEach(ele => {
					ele.addEventListener('click', (e) => {
						let targetName = e.currentTarget.getAttribute('data-name');
						let targetValue = e.currentTarget.getAttribute('data-value');
						const newParams = new URLSearchParams();
						for (const [key, value] of urlParams.entries()) {
							if (!((key === targetName || key === (targetName + '_1') || key === (targetName + '_2') || key === (targetName + '_3') || key === (targetName.split('_')[0] + '_1' + targetName.split('_')[1]) || key === (targetName.split('_')[0] + '_2' + targetName.split('_')[1]) || key === (targetName.split('_')[0] + '_3' + targetName.split('_')[1])) && value === targetValue)) {
								newParams.append(key, value); // 条件に合わないものだけ追加
							}
						}
						// URLを更新
						urlObj.search = newParams.toString();
						const updatedUrl = urlObj.toString();
						location.href = updatedUrl;
					});
				});
			}
		}
	}

	// 中カテゴリ　検索メニュー開閉　クリアボタン
	const searchMenu = () => {
		const menu = document.querySelectorAll('.js-productsMenu');
		const menuBtn = document.querySelectorAll('.js-productsMenu-btn');
		const menuConts = document.querySelectorAll('.js-productsMenu-conts');
		const menuSubmit = document.querySelector('.js-productsMenu-submit');
		let menuSubmitPosition = 0;

		// 桁数に基づいて+1(+0.1、+0.01・・・)
		const adjustMaxValue = (maxValue) => {
			// // 小数点以下の桁数を取得
			// let decimalPlaces = (maxValue % 1 === 0) ? 0 : maxValue.toString().split('.')[1].length;
			// // 加算する値を動的に決定 (10のマイナス乗)
			// let increment = Math.pow(10, -decimalPlaces);
			// // maxValue に適切な値を加算
			// return Number(maxValue) + increment;
			return maxValue;
		}

		if (menu.length) {
			menuBtn.forEach((ele) => {
				ele.addEventListener('click', () => {
					menu.forEach((btn) => { btn.classList.toggle(a) })
					menuConts.forEach((conts) => { conts.classList.toggle(a) })

					// 検索ボタンのポジション取得
					if (menuSubmitPosition <= 0) {
						menuSubmitPosition = menuSubmit.getBoundingClientRect().top;
					}
				});
			});

			menu.forEach((ele) => {
				const menuSubmitBtn = ele.querySelector('.js-productsMenu-submit-btn');
				const menuClear = ele.querySelector('.js-productsMenu-clear');

				let menuToggleItems = ele.querySelectorAll('.js-toggle');
				if (menuToggleItems.length) {
					menuToggleItems.forEach(item => {
						let itemHeight = 0;
						item.addEventListener('click', () => {
							let nextSibling = item.nextElementSibling; // 次の兄弟要素を取得
							if (nextSibling && nextSibling.classList.contains('js-toggleBlock')) {
								setTimeout(() => {
									if (item.classList.contains('is-active')) {
										itemHeight = nextSibling.offsetHeight; // 高さを取得
										menuSubmitPosition += itemHeight;
									} else {
										menuSubmitPosition -= itemHeight;
									}
								}, 300);
							}
						});
					});
				}


				// 検索ボタンクリック
				if (menuSubmitBtn) {
					menuSubmitBtn.addEventListener('click', () => {
						const params = [];

						// チェックが入っているチェックボックスを取得
						const checkedCheckboxes = ele.querySelectorAll('input[type="checkbox"]:checked');
						if (checkedCheckboxes.length) {
							checkedCheckboxes.forEach(checkbox => {
								params.push(`${encodeURIComponent(checkbox.name)}=${encodeURIComponent(checkbox.value)}`);
							});
						}

						// テキストが入力されているテキストボックスを取得
						const filledTextInputs = ele.querySelectorAll('input[type="text"]');
						if (filledTextInputs.length) {
							filledTextInputs.forEach(input => {
								let thisValue = input.value.trim();
								if (thisValue !== '') {
									// 最小_最大のパターン
									if (input.name.includes('_min') || input.name.includes('_max')) {
										if (input.name.includes('_x') || input.name.includes('_y')) {
											let thisName = input.name.split('_')[0];
											let thisAxis = input.name.split('_')[1];
											let minValue = ele.querySelector('input[type="text"][name="' + thisName + '_' + thisAxis + '_min"]').value.trim();
											let maxValue = ele.querySelector('input[type="text"][name="' + thisName + '_' + thisAxis + '_max"]').value.trim();
											maxValue = adjustMaxValue(maxValue);
											// パラメータの生成と追加
											if (/^angle_(x|y)_(min|max)$/.test(input.name)) {
												// 指向半値角の場合
												for (let i = 1; i <= 3; i++) {
													let thisParam = `${thisName}_${i}${thisAxis}=${minValue}_${maxValue}`;
													if (!params.includes(thisParam)) {
														params.push(thisParam);
													}
												}
											} else {
												let thisParam = `${thisName}_${thisAxis}=${minValue}_${maxValue}`;
												if (!params.includes(thisParam)) {
													params.push(thisParam);
												}
											}
										} else {
											let thisName = input.name.replace(/_(min|max)$/, '');
											let minValue = ele.querySelector('input[type="text"][name="' + thisName + '_min"]').value.trim();
											let maxValue = ele.querySelector('input[type="text"][name="' + thisName + '_max"]').value.trim();
											maxValue = adjustMaxValue(maxValue);

											if (!$path.includes('/products/category/uv-disinfection/') && (/^dominant_(min|max)$/.test(input.name) || /^intensity_(min|max)$/.test(input.name) || /^flux_(min|max)$/.test(input.name) || /^current_(min|max)$/.test(input.name) || /^voltage_(min|max)$/.test(input.name))) {
												for (let i = 1; i <= 3; i++) {
													let thisParam = `${thisName}_${i}=${minValue}_${maxValue}`;
													if (!params.includes(thisParam)) {
														params.push(thisParam);
													}
												}
											} else {
												// パラメータの生成と追加
												let thisParam = `${thisName}=${minValue}_${maxValue}`;
												if (!params.includes(thisParam)) {
													params.push(thisParam);
												}
											}
										}
									} else {
										params.push(`${encodeURIComponent(input.name)}=${encodeURIComponent(thisValue)}`);
									}
								}
							});
						}

						// パラメータを結合して出力
						const queryString = params.join('&');
						window.location.href = $path + '?' + queryString;
					});
				}

				// クリアボタンクリック
				if (menuClear) {
					menuClear.addEventListener('click', () => {
						location.href = $path;
					});
				}
			});
		}
		// 検索ボタン挙動
		if (menuSubmit) {
			window.addEventListener('scroll', () => {
				const viewportHeight = window.innerHeight;
				const scrollPosition = window.scrollY;

				// 検索ボタンをfixedにする
				if (scrollPosition + viewportHeight <= menuSubmitPosition) {
					menuSubmit.classList.add('is-fixed');
				} else {
					menuSubmit.classList.remove('is-fixed');
				}
			});
		}

		// TABLETとSPではデフォルトでメニュー閉じる
		if (menu.length) {
			let isMobile = window.innerWidth <= 1024;
			const handleResize = () => {
				let currentIsMobile = window.innerWidth <= 1024;
				// TABLET/SP
				if (currentIsMobile && !isMobile) {
					toggleMenu();
				}
				// PC
				if (!currentIsMobile && isMobile) {
					toggleMenu();
				}
				isMobile = currentIsMobile; // 状態を更新
			}

			const toggleMenu = () => {
				menuConts.forEach((ele) => {
					ele.classList.toggle(a);
				});

				menu.forEach((ele) => {
					ele.classList.toggle(a);
				});
			};

			// 初期表示
			if (isMobile) {
				toggleMenu();
			}
			// リサイズ時
			window.addEventListener("resize", handleResize);
		}
	}
	// スクロール連動
	const scrollTable = () => {
		
		const scrollTbl = document.querySelectorAll('.js-scroll-table');

		if (!scrollTbl.length) return;

		// ヘッダーの高さを動的に取得
		const getHeaderHeight = () => (window.innerWidth >= 1025 ? 80 : 50);

		// 横幅を同期
		const syncColumnWidths = (originalThead, clonedThead) => {
			const originalThs = originalThead.querySelectorAll("th");
			const clonedThs = clonedThead.querySelectorAll("th");

			if (originalThs.length !== clonedThs.length) {
				console.warn("列数が一致しません");
				return;
			}

			originalThs.forEach((originalTh, index) => {
				const clonedTh = clonedThs[index];
				clonedTh.style.width = `${originalTh.offsetWidth}px`;
			});
		};

		// スクロールイベント処理
		const handleScroll = () => {
			const headerHeight = getHeaderHeight();
			scrollTbl.forEach((table) => {
				const tbody = table.querySelector(".products-cat-tblWrap:not(.fixed-thead) tbody");
				const rect = table.getBoundingClientRect();
				const scrollY = window.scrollY;

				const tblTh = table.querySelector(".products-cat-tblWrap:not(.fixed-thead) thead");
				const cloneTbl = table.querySelector(".fixed-thead");
				const cloneTh = cloneTbl.querySelector(".products-cat-tbl");
				const tblWidth = table.offsetWidth;
				const thHeight = tblTh.offsetHeight;
				const bodyWidth = tbody.offsetWidth;
				const scrollBar = table.querySelector(".scroll-container");
				const scrollBarInner = table.querySelector(".scroll-container-inner");
				const tbodyLeft = rect.left;

				const tableTop = rect.top + scrollY;
				const tableBottom = tableTop + table.offsetHeight;

				if (scrollY + headerHeight >= tableTop && scrollY < tableBottom - headerHeight) {
					table.classList.add("is-fixed");
					cloneTbl.style.width = `${tblWidth}px`;
					cloneTh.style.width = `${bodyWidth}px`;
					scrollBar.style.position = "fixed";
					scrollBar.style.width = `${tblWidth}px`;
					scrollBar.style.top = `${thHeight + headerHeight - 12}px`;
					scrollBar.style.left = `${tbodyLeft}px`;
					scrollBarInner.style.width = `${bodyWidth}px`;

					// 固定されたtheadのthの幅を元のtheadのthと同期
					syncColumnWidths(tblTh, cloneTh);
				} else {
					table.classList.remove("is-fixed");
					scrollBar.style.position = "absolute";
					scrollBar.style.width = `${tblWidth}px`;
					scrollBar.style.top = `${thHeight - 11}px`;
					scrollBar.style.left = "0";
				}
			});
		};

		// リサイズイベント処理
		const handleResize = () => {
			scrollTbl.forEach((table) => {
				const tbody = table.querySelector("tbody");
				const rect = tbody.getBoundingClientRect();
				const tbodyLeft = rect.left;
				const scrollBar = table.querySelector(".scroll-container");

				if (scrollBar.classList.contains("is-fixed")) {
					scrollBar.style.left = `${tbodyLeft}px`;
				}
			});

			handleScroll();
		};

		// 初期設定
		const initTables = () => {
			scrollTbl.forEach((table) => {
				const thisTable = table.querySelector(".products-cat-tblWrap");
				const originalThead = thisTable.querySelector("thead");

				if (!table.querySelector('.fixed-thead')) {
					const clonedThead = originalThead.cloneNode(true);
					const wrapperTable = document.createElement("table");
					wrapperTable.classList.add("products-cat-tbl", "width-u-100");
					wrapperTable.appendChild(clonedThead);

					const wrapperDiv = document.createElement("div");
					wrapperDiv.classList.add("products-cat-tblWrap", "fixed-thead");
					wrapperDiv.appendChild(wrapperTable);

					thisTable.parentNode.insertBefore(wrapperDiv, thisTable);

					// 固定される前に横幅を同期
					syncColumnWidths(originalThead, clonedThead);
					window.addEventListener("resize", () => syncColumnWidths(originalThead, clonedThead));
				}
			});
		};

		// 初期状態の確認
		const updateDimensions = () => {
			scrollTbl.forEach((elem) => {
				const tableContainer = elem.querySelector('.products-cat-tblWrap:not(.fixed-thead)');
				const scrollContainer = elem.querySelector('.scroll-container');
				const scrollContainerInner = elem.querySelector('.scroll-container-inner');
				const table = tableContainer.querySelector('.products-cat-tbl');
				const thead = elem.querySelector('.products-cat-tbl thead');

				if (!table || !thead || !scrollContainerInner) return;

				const tableW = table.querySelector('tbody').offsetWidth;
				scrollContainerInner.style.width = `${tableW}px`;

				const theadH = thead.getBoundingClientRect().height || thead.offsetHeight;
				scrollContainer.style.top = `${theadH - 11}px`;
			});
		};

		const syncScroll = (source, target) => {
			source.addEventListener('scroll', () => {
				target.scrollLeft = source.scrollLeft;
			}, { passive: false });
		};

		// スクロール同期
		const syncTableScroll = () => {
			scrollTbl.forEach((elem) => {
				const scrollContainer = elem.querySelector('.scroll-container');
				const tableContainer = elem.querySelector('.products-cat-tblWrap:not(.fixed-thead)');
				const cloneTh = elem.querySelector('.fixed-thead');

				syncScroll(scrollContainer, tableContainer);
				syncScroll(tableContainer, scrollContainer);
				syncScroll(cloneTh, tableContainer);
				syncScroll(tableContainer, cloneTh);
				syncScroll(scrollContainer, cloneTh);
			});
		};

		// 初期化
		initTables();
		updateDimensions();
		handleScroll();

		// イベントリスナー
		window.addEventListener("scroll", handleScroll);
		window.addEventListener("resize", handleResize);

		// スクロール同期
		syncTableScroll();
	};
	// テーブル　ソート機能
	const sortTable = () => {
		const tbl = document.querySelectorAll('.js-sortTable');
		if (tbl.length) {
			tbl.forEach(elem => {
				let sortBox = elem.querySelector('.js-sorBox')
				let sortBoxBtn = elem.querySelector('.js-sorBox-btn')
				if (sortBoxBtn) {
					// sortBoxBtn.addEventListener('click', e => {
					// 	sortBox.classList.toggle(a);
					// });

					// // sortBox以外の場所がクリックされたとき
					// document.addEventListener('click', (e) => {
					// 	if (!e.target.closest('.js-sorBox, .js-sorBox-btn')) {
					// 		sortBox.classList.remove(a);
					// 	}
					// });
				}
			})
		}
	}

	// <照明器具TOP> ============================================
	// 導入事例スライド
	const caseSplide = () => {
		if (document.querySelector('.js-products-case')) {
			let splide = new Splide('.js-products-case.splide', {
				rewind: true,
				perPage: 1,
				autoplay: true,
				interval: 5000,
				speed: 2000,
				gap: 24,
				arrows: true,
				pagination: true,
				paginationKeyboard: false,
			}).mount();
		}
	};
	// <自動車用電球・アクセサリー>============================================
	// 中カテゴリ
	const createAccessoriesSmallCategory = () => {
		const accessories = document.querySelector('.js-accessories-list');
		if (accessories) {
			accessories.querySelectorAll('.rt_bn_product_category_m').forEach(elem => {
				let _key = elem.querySelector('._key').textContent;
				let output = elem.querySelector('.js-sCategory-list');
				fetch(accessoriesSmallCategoryJson(_key))
					.then(response => response.json())
					.then((data) => {
						let categoryData = data.rt_bn_product_category_s;

						if (categoryData.length) {
							for (let i = 0; i < categoryData.length; i++) {
								let name = categoryData[i].cf_pcs_name_jp;
								if (basePath === 'en') {
									name = categoryData[i].cf_pcs_name_en;
								}
								let href = categoryData[i].rt_cf_pcs_href.href;
								let thisHtml = `<li><a href="${href}" class="__link"><span>${name}</span></a></li>`;
								output.insertAdjacentHTML('beforeend', thisHtml);
							}
						}
					})
					.catch(error => {
						// エラーハンドリング
						console.error('Error:', error);
					});
			})
		}
	};
	//子カテゴリ見出し挿入
	const createAccessoriesSmallCategoryHead = () => {
		const categoryBlock = document.querySelector('.js-sCategory-block');
		let previousCategory = '';
		let previousCategoryKey = '';

		let mCategory = $path.split('/')[5];
		let mCategoryArr = ['ledbulb', 'hyperbulb', 'incandescent', 'halogen', 'other'];
		const anchorBlock = document.querySelector('.js-accessories-anchor');
		let anchorLinkHtml = '';

		if (categoryBlock) {
			const listItems = document.querySelectorAll('li.__column_4.__column_tab_2.rt_bn_product');

			// セクション
			let newSection = document.createElement('section');
			// ul
			let newUl = document.createElement('ul');
			newUl.classList.add('mod-column');
			let headHtml = '';
			let allHtml = '';

			listItems.forEach((item, index) => {
				// カテゴリ名の取得
				const category = item.querySelector('span.rt_cf_p_category_s_name').textContent.trim();
				const thisKey = item.querySelector('.rt_cf_p_category_s_key').textContent;

				if (index == 0) {
					headHtml = '<h2 id="' + thisKey + '" class="mod-head05">' + category + '</h2>';
					// アンカーリンク生成
					if(anchorBlock && mCategoryArr.includes(mCategory)) {
						anchorLinkHtml += `<li><a href="#${thisKey}" rel="scroll"><span>${category}</span><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_bottom"></use></svg></a></li>`;
						categoryBlock.classList.add('mod-spacer_56');
					}
				}
				// 現在のカテゴリ名と前回のカテゴリ名が異なる場合
				if (category !== previousCategory && index !== 0) {
					headHtml = '<h2 id="' + previousCategoryKey + '" class="mod-head05">' + previousCategory + '</h2>';

					// sectionを親要素に追加
					newSection.insertAdjacentHTML('beforeend', headHtml);
					newSection.appendChild(newUl);
					allHtml += newSection.outerHTML;


					// 新しいsectionを作成
					newSection = document.createElement('section');
					newSection.classList.add('mod-spacer-section');
					headHtml = '<h2 id="' + thisKey + '" class="mod-head05">' + category + '</h2>';
					newUl = document.createElement('ul');
					newUl.classList.add('mod-column');

					// アンカーリンク生成
					if(anchorBlock && mCategoryArr.includes(mCategory)) {
						anchorLinkHtml += `<li><a href="#${thisKey}" rel="scroll"><span>${category}</span><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_bottom"></use></svg></a></li>`;
					}
				}

				// 現在のliを新しいulに追加
				const clonedItem = item.cloneNode(true); // 元の要素をコピー
				newUl.appendChild(clonedItem);

				// 前回のカテゴリ名を更新
				previousCategory = category;
				previousCategoryKey = thisKey;
			});

			// 最後のセクションを追加
			newSection.appendChild(newUl);
			newSection.insertAdjacentHTML('afterbegin', headHtml);
			allHtml += newSection.outerHTML;
			categoryBlock.innerHTML = allHtml;
			anchorBlock.querySelector('.mod-anchorLink').innerHTML = anchorLinkHtml;

		}
	}
	// 車から探す
	const carSearchMenu = () => {
		const carMenu = document.querySelector('.js-carMenu');
		if (carMenu) {
			const submitBtn = carMenu.querySelector('.__submit');
			const inputText = carMenu.querySelector('.mod-inputText input');
			const selectBox = carMenu.querySelector('.js-carMenu-selectBox');

			submitBtn.addEventListener('click', () => {
				function convertString(input) {
					// 1. 全角英数記号 → 半角英数記号
					// 2. 半角カナ → 全角カナ
					// この2つの要件をNFKCのnormalizeで同時に満たします
					let result = input.normalize('NFKC');
					// 3. ひらがな → カタカナ
					result = result.replace(/[ぁ-ん]/g, char => String.fromCharCode(char.charCodeAt(0) + 0x60));
					return result;
				}
				inputText.value = convertString(inputText.value);
			});

			if (selectBox) {
				selectBox.querySelectorAll('.mod-select02-list-option a').forEach(item => {
					let itemHref = item.getAttribute('href');
					if ($path.includes(itemHref)) {
						let thisText = item.textContent;
						selectBox.querySelector('.__selected').textContent = thisText;
					}
				});
			}
		}
	}

	// メーカー希望小売価格
	const updatePriceDisplay = () => {
		const priceItem = document.querySelectorAll('.js-products-price');
		if (priceItem.length) {
			function formatPrice(price) {
				return price.toLocaleString();
			};
			priceItem.forEach(element => {
				const priceText = element.textContent || element.innerText; // 価格のテキストを取得
				const priceMatch = priceText.match(/\d+/); // 数字部分を取得
				const unit = priceText.replace(priceMatch, '');

				if (priceMatch) {
					const price = parseInt(priceMatch[0], 10); // 数字を整数に変換
					const formattedPrice = formatPrice(price); // カンマ区切りにフォーマット
					element.textContent = formattedPrice + unit; // 新しい価格を表示
				}
			});

		}
	}
	// <大カテゴリ(深紫外)> ============================================
	// 小カテゴリリンク判定
	const uvSterilizationSmallCategoryLink = () => {
		const categoryList = document.querySelectorAll('.js-uvSterilization-list');
		if (categoryList.length) {
			categoryList.forEach(elem => {
				let sCategory = elem.querySelectorAll('li.__column_6');
				sCategory.forEach(item => {
					let _key = item.querySelector('._key').textContent;
					fetch(uvSterilizationSmallCategoryJson(_key))
						.then(response => response.json())
						.then((data) => {
							let productsData = data.rt_bn_product;
							if (productsData.length) {
								let firstItem = productsData[0];
								if (firstItem.rt_bn_product_total === 1) {
									let thisLink = item.querySelector('a.mod-products');
									let thisHref = firstItem["rt_cf_pcs_href_uv-sterilization"];
									thisLink.setAttribute('href', thisHref);
								}
							}
						})
						.catch(error => {
							// エラーハンドリング
							console.error('Error:', error);
						});
				});
			});
		}
	}

	// <業界別ソリューション一覧> ============================================
	// 小カテゴリ表示／非表示判定
	const appRelationLinks = () => {
		const categoryLink = document.querySelectorAll('.js-application-sCategory');
		const productsLink = document.querySelectorAll('.js-application-product');

		if (categoryLink.length) {
			categoryLink.forEach(elem => {
				let thisKey = elem.querySelector('.rt_cf_as_category_s_key').textContent;
				fetch(returnMiddleCategoryStatus(thisKey))
					.then(response => response.json())
					.then((data) => {
						let categoryData = data.rt_bn_category_s;
						if (categoryData && categoryData.length) {
							let sCatStatus = categoryData[0]?.cf_pcs_status_jp;
							let mCatStatus = categoryData[0]?.cf_pcs_category_m?.cf_pcm_status_jp;
							let lCatStatus = categoryData[0]?.cf_pcs_category_l?.cf_pcl_status_jp;
							if (basePath === 'en') {
								sCatStatus = categoryData[0]?.cf_pcs_status_en;
								mCatStatus = categoryData[0]?.cf_pcs_category_m?.cf_pcm_status_en;
								lCatStatus = categoryData[0]?.cf_pcs_category_l?.cf_pcl_status_en;
							} else if (basePath === 'cn') {
								sCatStatus = categoryData[0]?.cf_pcs_status_ch;
								mCatStatus = categoryData[0]?.cf_pcs_category_m?.cf_pcm_status_ch;
								lCatStatus = categoryData[0]?.cf_pcs_category_l?.cf_pcl_status_ch;
							}

							if (sCatStatus === 0) {
								elem.remove();
							} else if (mCatStatus === 0) {
								elem.remove();
							} else if (lCatStatus === 0) {
								elem.remove();
							} else {
								elem.classList.remove('di_none');
							}
						}
					})
			})
		}
		if (productsLink.length) {
			productsLink.forEach(elem => {
				let thisKey = elem.querySelector('.rt_cf_as_product_key').textContent;
				fetch(returnProductsStatus(thisKey))
					.then(response => response.json())
					.then((data) => {
						let productsData = data.rt_bn_product;
						if (productsData && productsData.length) {
							if (productsData[0]?.cf_p_status_jp === 0) {
								elem.remove();
							} else if (productsData[0]?.cf_p_category_l?.cf_pcl_status_jp === 0) {
								elem.remove();
							} else if (productsData[0]?.cf_p_category_m?.cf_pcm_status_jp === 0) {
								elem.remove();
							} else if (productsData[0]?.cf_p_category_s?.cf_pcs_status_jp === 0) {
								elem.remove();
							} else {
								elem.classList.remove('di_none');
							}
						}
					})
			})
		}

		// 小カテゴリの製品が1つしかなかった場合、製品詳細ページに遷移
		if (categoryLink.length) {
			categoryLink.forEach(elem => {
				let thisKey = elem.querySelector('.rt_cf_as_category_s_key').textContent;
				const appCode = $path.split('/')[$path.split('/').length - 2];
				fetch(solutionSeriesLinkJudgement(appCode, thisKey))
					.then(response => response.json())
					.then((data) => {
						let productsLink = data.rt_bn_series_link_judgement;
						if (productsLink && productsLink.length) {
							let thisLink = elem.querySelector('a.mod-boxLink04');
							let thisHref = productsLink[0].rt_cf_as_category_s_product_href;
							let total = productsLink[0].rt_bn_series_link_judgement_total;
							if (total === 1) {
								thisLink.setAttribute('href', thisHref);
							}
						}
					})
					.catch(error => {
						console.error('Fetch error:', error);
					});
			});
		}
	}

	// <業界別ソリューション一覧>中カテゴリが非表示の場合はテーブルごと非表示／使用しないテーブルを非表示
	const appCategoryHidden = () => {
		let appBlock = document.querySelectorAll('.js-app-block');
		if (appBlock.length) {
			appBlock.forEach(block => {
				let headEml = block.querySelector('.mod-head03');
				if (headEml) {
					let thisKey = headEml.getAttribute('id');
					fetch(returnMiddleCategoryStatus(thisKey))
						.then(response => response.json())
						.then((data) => {
							let categoryData = data.rt_bn_category_s;
							if (categoryData && categoryData.length) {
								let sCatStatus = categoryData[0]?.cf_pcs_status_jp;
								let mCatStatus = categoryData[0]?.cf_pcs_category_m?.cf_pcm_status_jp;
								let lCatStatus = categoryData[0]?.cf_pcs_category_l?.cf_pcl_status_jp;
								if (basePath === 'en') {
									sCatStatus = categoryData[0]?.cf_pcs_status_en;
									mCatStatus = categoryData[0]?.cf_pcs_category_m?.cf_pcm_status_en;
									lCatStatus = categoryData[0]?.cf_pcs_category_l?.cf_pcl_status_en;
								} else if (basePath === 'cn') {
									sCatStatus = categoryData[0]?.cf_pcs_status_ch;
									mCatStatus = categoryData[0]?.cf_pcs_category_m?.cf_pcm_status_ch;
									lCatStatus = categoryData[0]?.cf_pcs_category_l?.cf_pcl_status_ch;
								}

								if (sCatStatus === 0) {
									block.remove();
								} else if (mCatStatus === 0) {
									block.remove();
								} else if (lCatStatus === 0) {
									block.remove();
								} else {
									block.classList.remove('di_none');
								}
							}
						})
						.catch(error => {
							console.error('Fetch error:', error);
						});
					
					// テーブル表示／非表示
					fetch(solutionSmallCategoryJudgement(thisKey))
						.then(response => response.json())
						.then((data) => {
							let categoryData = data.rt_bn_p_category_s;
							if(categoryData.length) {
								let lCategory = categoryData[0].rt_cf_pcs_category_l_is;
								let mCategory = categoryData[0].rt_cf_pcs_category_m_judgement_for_components;
								let judgementForUv = categoryData[0].rt_cf_pcs_key_judgement_for_uv;
								
								if(lCategory === 'components') {
									// コンポーネンツ
									if(mCategory === 'not_ambientlight') {
										block.querySelector('.js-app-block .js-tbl01').classList.remove('di_none');
									} else if(mCategory === 'ambientlight') {
										block.querySelector('.js-app-block .js-tbl02').classList.remove('di_none');
									} else if(mCategory === 'deep_near_infrared') {
										block.classList.add('infrared-led');
										block.querySelector('.js-app-block .js-tbl03').classList.remove('di_none');
									} else if(mCategory === 'vcsel') {
										block.querySelector('.js-app-block .js-tbl04').classList.remove('di_none');
									} else if(mCategory === 'sensor') {
										block.querySelector('.js-app-block .js-tbl05').classList.remove('di_none');
									} else if(mCategory === 'uv-ccl') {
										block.querySelector('.js-app-block .js-tbl06').classList.remove('di_none');
									}
								} else {
									// 紫外線除菌製品
									if(judgementForUv === 'uvcled_reactor') {
										block.querySelector('.js-app-block .js-tbl07').classList.remove('di_none');
									} else if(judgementForUv === 'uvcled_disinfection') {
										block.querySelector('.js-app-block .js-tbl08').classList.remove('di_none');
									} else if(judgementForUv === 'uvccl_reactor') {
										block.querySelector('.js-app-block .js-tbl09').classList.remove('di_none');
									}
								}
							}
						})
						.catch(error => {
							console.error('Fetch error:', error);
						});
				} else {
					block.remove();
				}
			});
		}

	}
	

	// <製品詳細> ============================================
	// 商品画像スライド
	const detailImgSlide = () => {
		let imgSlide = document.querySelectorAll('.js-products-detail-slide')
		if (imgSlide.length) {
			imgSlide.forEach(elem => {
				const main = new Splide(elem, {
					rewind: true,
					perPage: 1,
					autoplay: false,
					interval: 5000,
					speed: 2000,
					gap: 24,
					arrows: true,
					pagination: true,
					paginationKeyboard: false,
				}).mount();

				// サムネイル作成
				elem.querySelectorAll('.splide__slide img').forEach((imgElem, idx) => {
					let listItem = elem.querySelectorAll('.splide__pagination li')[idx];
					if (listItem) {
						let button = listItem.querySelector('button');
						if (button) {
							let img = document.createElement('img');
							img.src = imgElem.src;
							button.appendChild(img);
						}
					}
				});
			})
		}
	}
	// 採用事例 空のliタグを削除
	const detailCaseRemove = () => {
		const caseSlide = document.querySelector('.js-products-detail-case');
		if (caseSlide) {
			let item = caseSlide.querySelectorAll('.splide__slide');
			item.forEach(ele => {
				if (ele.innerHTML.trim() === '') {
					ele.remove();
				}
			});
		}
	}
	// 採用事例スライド
	const detailCaseSlide = () => {
		if (document.querySelector('.js-products-detail-case')) {
			let splide = new Splide('.js-products-detail-case.splide', {
				rewind: true,
				perPage: 3,
				autoplay: false,
				interval: 5000,
				speed: 2000,
				gap: 20,
				arrows: true,
				pagination: true,
				paginationKeyboard: false,
				breakpoints: {
					1025: {
						destroy: false,
						perPage: 1,
					}
				},
			}).mount();
		}
	}
	// 空タグ削除
	const detailEmptyTagRemove = () => {
		let tagList = document.querySelectorAll('.products-detail-main-info-features');
		if (tagList.length) {
			tagList.forEach(ele => {
				let thisTag = ele.querySelectorAll('.cf_p_tags');
				thisTag.forEach(item => {
					if (!item.textContent.trim()) {
						item.remove();
					}
				});
			})
		}
		let tagList2 = document.querySelectorAll('.products-detail-main-info-features02');
		if (tagList2.length) {
			tagList2.forEach(ele => {
				let thisTag = ele.querySelectorAll('.cf_p_tags');
				thisTag.forEach(item => {
					if (!item.textContent.trim()) {
						item.remove();
					}
				});
			})
		}

		// 「開発品」周りの空タグを削除
		let infoTagList = document.querySelectorAll('.products-detail-main-info-tags .__label');
		if (infoTagList.length) {
			infoTagList.forEach(ele => {
				if (!ele.textContent.trim()) {
					ele.remove();
				}
			})
		}
	}
	// 関連商品空li削除
	const detailEmptyRelationProductsRemove = () => {
		let tagList = document.querySelectorAll('.js-relationProducts-list');
		if (tagList.length) {
			tagList.forEach(ele => {
				let thisTag = ele.querySelectorAll('.rt_bn_related_product_category_s');
				thisTag.forEach(item => {
					if (!item.querySelector('.mod-products')) {
						item.remove();
					}
				});
			})
		}
	}
	// 関連商品の小カテゴリリンク　紐づく製品が1件の場合、リンクURL書き換え
	const detailRelationProductsLinkChange = () => {
		let tagList = document.querySelectorAll('.js-relationProducts-list');
		if (tagList.length) {
			const items = tagList[0].querySelectorAll('.__column_6');
			items.forEach(li => {
				if (li.querySelector('._key')) {
					let thisCatKey = li.querySelector('._key').textContent;
					fetch(uvSterilizationSmallCategoryJson(thisCatKey))
						.then(response => response.json())
						.then((data) => {
							let productsData = data.rt_bn_product;
							if (productsData.length) {
								if (productsData[0].rt_bn_product_total === 1) {
									li.querySelector('.mod-products').setAttribute('href', productsData[0]['rt_cf_pcs_href_uv-sterilization']);
								}
							}
						})
				}
			});
		}
	}
	// NEWマーク
	const detailNewMark = () => {
		const newTag = document.querySelector('.js-new');
		if (newTag) {
			const productsId = $path.split('/')[$path.split('/').length - 1].replace('.html', '');

			fetch(returnNew(productsId))
				.then(response => response.json())
				.then((data) => {
					if (data.rt_bn_product_info.length) {
						newTag.classList.remove('di_none');
					}
				})
		}
	}
	// <製品詳細（A&D）>関連製品描画
	const detailCreateRelationProducts = async () => {
		const outputWrap = document.querySelector('.js-relation-products');
		const output = document.querySelector('.js-relationProducts-output');
		const typeTag = document.querySelector('.__txt.rt_cf_p_type');
		let htmlTemplate = '/common/js/html/products-accessories-panel.html';
		if (basePath === 'en') {
			htmlTemplate = '/common/js/html/products-accessories-panel_en.html';
		}

		let html = await fetch(htmlTemplate).then(res => res.text());
		if (output) {
			if (typeTag) {
				const type = typeTag.textContent;
				const productsId = $path.split('/')[$path.split('/').length - 1].replace('.html', '');
				let allHtml = '';
				fetch(accessoriesRelationProductsJson(productsId, type))
					.then(response => response.json())
					.then((data) => {
						let productsData = data.rt_bn_product;
						if (productsData.length) {
							for (let i = 0; i < productsData.length; i++) {
								let _name = productsData[i].cf_p_name_jp;
								if (basePath === 'en') {
									_name = productsData[i].cf_p_name_en;
								} else if (basePath === 'cn') {
									_name = productsData[i].cf_p_name_ch;
								}
								let _href = productsData[i].rt_cf_p_href.href;
								let _img = productsData[i].rt_cf_p_thum_img;
								let thumbImg = '';
								let thumbAlt = '';
								let thumbTit = '';
								if (_img !== null) {
									thumbImg = _img.src;
									thumbAlt = _img.alt;
									thumbTit = _img.title;
								};
								let _type = productsData[i].cf_p_type_jp;
								if (basePath === 'en') {
									_type = productsData[i].cf_p_type_en;
								} else if (basePath === 'cn') {
									_type = productsData[i].cf_p_type_ch;
								}
								let _ratingLed = productsData[i].cf_p_rating_led_jp;
								if (basePath === 'en') {
									_ratingLed = productsData[i].cf_p_rating_led_en;
								} else if (basePath === 'cn') {
									_ratingLed = productsData[i].cf_p_rating_led_ch;
								}
								let _colorTemperature = productsData[i].cf_p_color_temperature_jp;
								if (basePath === 'en') {
									_colorTemperature = productsData[i].cf_p_color_temperature_en;
								} else if (basePath === 'cn') {
									_colorTemperature = productsData[i].cf_p_color_temperature_ch;
								}
								let _color = productsData[i].cf_p_led_color_jp;
								if (basePath === 'en') {
									_color = productsData[i].cf_p_led_color_en;
								} else if (basePath === 'cn') {
									_color = productsData[i].cf_p_led_color_ch;
								}
								let _quantity = productsData[i].cf_p_quantity_jp;
								if (basePath === 'en') {
									_quantity = productsData[i].cf_p_quantity_en;
								} else if (basePath === 'cn') {
									_quantity = productsData[i].cf_p_quantity_ch;
								}
								let _tags = productsData[i].cf_p_tags;
								let _jan = productsData[i].cf_p_jan_jp;
								if (basePath === 'en') {
									_jan = productsData[i].cf_p_jan_en;
								} else if (basePath === 'cn') {
									_jan = productsData[i].cf_p_jan_ch;
								}
								let _price = productsData[i].cf_p_price_jp;
								if (basePath === 'en') {
									_price = productsData[i].cf_p_price_en;
								} else if (basePath === 'cn') {
									_price = productsData[i].cf_p_price_ch;
								}
								let _new = productsData[i].rt_cf_p_new_icon;

								let tagHtml = '';
								let newHtml = '';
								if (_tags.length) {
									tagHtml += '<ul class="mod-products-tags">';
									_tags.forEach(elem => {
										if (elem.rt_cf_p_tags_feature_accesory !== null) {
											tagHtml += `<li><span class="__tag">${elem.rt_cf_p_tags_feature_accesory.content}</span></li>`;
										}
									});
									tagHtml += '</ul>';
								}
								if (_new !== null) {
									newHtml = '<span class="__new">NEW</span>';
								}

								let thisHtml = html
									.replaceAll('{!name!}', _name)
									.replaceAll('{!href!}', _href)
									.replaceAll('{!img!}', thumbImg)
									.replaceAll('{!alt!}', thumbAlt)
									.replaceAll('{!imgTitle!}', thumbTit)
									.replaceAll('{!type!}', _type)
									.replaceAll('{!ratingLed!}', _ratingLed)
									.replaceAll('{!colorTemperature!}', _colorTemperature)
									.replaceAll('{!color!}', _color)
									.replaceAll('{!quantity!}', _quantity)
									.replaceAll('{!tags!}', tagHtml)
									.replaceAll('{!jan!}', _jan)
									.replaceAll('{!price!}', _price)
									.replaceAll('{!new!}', newHtml)

								allHtml += thisHtml;
							}
						} else {
							// 0件の場合、エリアごと非表示
							outputWrap.remove();
						}
					})
					.then(() => {
						output.innerHTML = allHtml;
					})
					.catch(error => {
						// エラーハンドリング
						console.error('Error:', error);
					});
			} else {
				outputWrap.remove();
			}
		}
	}

	// <製品詳細（紫外線除菌）>
	const detailDimensions = () => {
		const dimensions = document.querySelector('.js-products-detail-dimensions');
		if (dimensions) {
			const item = dimensions.querySelectorAll('.mod-column li');
			if (item.length) {
				dimensions.classList.remove('di_none');
			}
		}
	}

	// <製品詳細（照明器具）>
	const detailLighting = () => {
		const illuminance = document.querySelector('.js-illuminance_calculation');
		if (illuminance) {
			if ($path.includes('/products/category/lighting/detail/llf0058a.html')) {
				illuminance.classList.remove('di_none');
			}
		}
	};
	// <製品詳細（照明器具）>
	const detailLightingCasestudy = () => {
		const casestudyBlock = document.querySelector('.js-casestudy-block');
		if(casestudyBlock) {
			let items = casestudyBlock.querySelectorAll('li a');
			if(!items.length) {
				casestudyBlock.classList.add('di_none');
			}
		}
	}

	// <製品詳細>コンポーネンツ製品
	const detailSeriesjudgement = () => {
		let seriesCodeSpan = document.querySelector('.js-seriesCode');
		const validKeys = ["ac", "1c", "4r", "8l", "2g", "5g", "bua", "tri-color", "4l"];
		const excludedProducts = ["vctw1152gds"];
		const key = $path.split('/')[$path.split('/').length - 1].replace('.html', '');

		const formatNumbers = (inputString) => {
			return inputString.split(", ")
				.map(num => parseFloat(num).toFixed(3)) // 小数点3桁にする
				.join(", ");
		}
		// // センサー
		// const formatNumbers2 = (inputString) => {
		// 	return inputString.split(", ")
		// 		.map(num => parseFloat(num).toFixed(1)) // 小数点1桁にする
		// 		.join(", ");
		// }
		// シリーズを指定
		if (seriesCodeSpan) {
			let seriesCode = seriesCodeSpan.textContent;
			if (validKeys.includes(seriesCode) && !excludedProducts.includes(key)) {
				let chromaticity = document.querySelector('.rt_cf_p_chromaticity_coordinates');
				let chromaticityTxt = document.querySelector('.rt_cf_p_chromaticity_coordinates').textContent;
				if (chromaticityTxt !== '') {
					chromaticity.textContent = formatNumbers(chromaticityTxt);
				}
			}
		}

		// センサーの値の桁を小数点1桁に
		const sensorItem = document.querySelectorAll('.js-sensorItem1');
		if(sensorItem.length) {
			let seriesCode = seriesCodeSpan.textContent;
			if(seriesCode === 'phototransistor') { //　フォトトランジスター
				sensorItem.forEach(ele => {
					if(ele.textContent.includes(' / ')) { // 立ち上がり時間／立ち下がり時間
						let num = parseFloat(ele.textContent.replace(' / ', '')).toFixed(1);
						ele.textContent = ' / ' + num;
					} else {
						ele.textContent = parseFloat(ele.textContent).toFixed(1);
					}
				});
			} else if(seriesCode === 'reflective_sensor') { // 反射センサー
				sensorItem.forEach(ele => {
					if(ele.textContent.includes(' / ')) {// 立ち下がり時間
						let num = parseFloat(ele.textContent.replace(' / ', '')).toFixed(0);
						ele.textContent = ' / ' + num;
					} else if(ele.classList.contains('rt_cf_p_rise_time') || ele.classList.contains('rt_cf_p_photocurrent')) {
						// 立ち上がり時間、光電流
						ele.textContent = parseFloat(ele.textContent).toFixed(0);
					} else {
						// 暗電流
						ele.textContent = parseFloat(ele.textContent).toFixed(1);
					}
				});
			} else if(seriesCode === 'photodiode') { // フォトダイオード
				sensorItem.forEach(ele => {
					if(ele.classList.contains('rt_cf_p_photocurrent')) { // 光電流
						ele.textContent = parseFloat(ele.textContent).toFixed(0);
					}
				});
			}
		}
	}

	// <特約店一覧> ======================================================
	const networkToggle = () => {
		const blockWrap = document.querySelectorAll('.js-network-block-wrap');

		const togglePc = () => {
			blockWrap.forEach((block) => {
				const toggleBtn = block.querySelectorAll('.js-network-toggle');
				const htmlBlock = block.querySelector('.js-network-block');

				toggleBtn.forEach((btn) => {
					btn.addEventListener('click', (e) => {
						// クリックされた要素以外のクラスを削除
						toggleBtn.forEach((otherBtn) => {
							if (otherBtn !== e.currentTarget) {
								otherBtn.classList.remove(a);
								const otherBlock = otherBtn.nextElementSibling;
								if (otherBlock) {
									otherBlock.classList.remove(a);
								}
							}
						});

						// クリックされた要素のクラスをトグル
						e.currentTarget.classList.toggle(a);
						const toggleBlock = e.currentTarget.nextElementSibling;

						if (toggleBlock) {
							toggleBlock.classList.toggle(a);

							// HTMLの更新処理
							const toggleBlockHtml = toggleBlock.innerHTML;
							if (toggleBlock.classList.contains(a)) {
								htmlBlock.innerHTML = toggleBlockHtml;
							} else {
								htmlBlock.innerHTML = '';
							}
						} else {
							console.log('toggleBlock not found');
						}
					});
				});
			});
		}

		const toggleSp = () => {
			const switchElements = document.querySelectorAll('.js-network-toggle');
			switchElements.forEach(switchElement => {
				switchElement.addEventListener('click', e => {
					e.currentTarget.classList.toggle(a);

					let toggleBlock = e.currentTarget.nextElementSibling;
					toggleBlock.classList.toggle(a);
					if (toggleBlock.style.height) {
						toggleBlock.style.height = null;
						toggleBlock.style.visibility = 'hidden';
					} else {
						toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
						toggleBlock.style.visibility = 'visible';
					}
				});
			});
		}

		let isExecutedForAbove1024 = false;  // 1024px以上で実行されたかを記録するフラグ
		let isExecutedForBelow1024 = false;  // 1024px以下で実行されたかを記録するフラグ

		function handleResize() {
			const windowWidth = window.innerWidth;

			// 1024px以上の場合、一度だけ実行
			if (windowWidth >= 1025 && !isExecutedForAbove1024) {
				togglePc();
				isExecutedForAbove1024 = true;
				isExecutedForBelow1024 = false;  // 1024px未満での実行をリセット
			}

			// 1024px未満の場合、一度だけ実行
			if (windowWidth < 1025 && !isExecutedForBelow1024) {
				toggleSp();
				isExecutedForBelow1024 = true;
				isExecutedForAbove1024 = false;  // 1024px以上での実行をリセット
			}
		}

		if (blockWrap.length) {
			// 最初に1回実行
			handleResize();
			// リサイズ時にイベントリスナーを追加
			window.addEventListener('resize', handleResize);
		}
	}

	// <採用事例> ======================================================
	// カテゴリプルダウン
	const caseDropDown = () => {
		const categoryList = document.querySelector('.js-case-categoryList');
		if (categoryList) {
			// ドロップダウンリスト要素を取得
			const categoryListUl = categoryList.querySelector('ul');
			const selectedSpan = categoryList.querySelector('.__selected')
			let allText = 'すべてのカテゴリー';
			if (basePath === 'en') {
				allText = 'All Categories';
			} else if (basePath === 'cn') {
				allText = '所有类别';
			}

			categoryListUl.innerHTML += `<li class="mod-select02-list-option" data-name="" role="option" tabindex="-1" aria-selected="false">${allText}</li>`;
			fetch(caseCategoryJson)
				.then(response => response.json())
				.then((data) => {
					const categoryData = data.rt_bn_category_info;
					if (categoryData.length) {
						for (let i = 0; i < categoryData.length; i++) {
							let thisCode = categoryData[i].cf_nc_code;
							let thisName = basePath === 'jp'
								? categoryData[i].cf_nc_name_jp
								: basePath === 'cn'
									? categoryData[i].cf_nc_name_ch
									: categoryData[i].cf_nc_name_en;

							const option = document.createElement('li');
							option.classList.add('mod-select02-list-option');
							option.setAttribute('data-name', thisCode);
							option.setAttribute('role', 'option');
							option.setAttribute('tabindex', -1);
							option.setAttribute('aria-selected', false);

							option.textContent = thisName;
							categoryListUl.appendChild(option);
							if ($path.includes(thisCode) && !$path.includes('/tag/')) {
								selectedSpan.textContent = thisName;
								selectedSpan.setAttribute('data-name', thisCode);
							}
						}
					}
				})
				.then(() => {
					// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
					categoryListUl.querySelectorAll('li').forEach(element => {
						element.addEventListener('click', (e) => {
							let selectedCat = e.currentTarget.getAttribute('data-name');
							let targetUrl = `/${basePath}/products/casestudy/${selectedCat ? selectedCat + '/' : ''}`;
							location.href = targetUrl;
						});
					});
				})
				.catch(error => {
					// エラーハンドリング
					console.error('Error:', error);
				});
		}
	};
	// 空タグ削除
	const casestudy = () => {
		if ($path.includes('/products/casestudy/')) {
			let movieTag = document.querySelectorAll('.__label.cf_n_tags');
			if (movieTag.length) {
				movieTag.forEach(ele => {
					if (!ele.textContent.trim()) {
						ele.remove();
					}
				});
			}
			let hashTagList = document.querySelectorAll('.mod-tags');
			if (hashTagList.length) {
				hashTagList.forEach(ele => {
					let thisHash = ele.querySelectorAll('.cf_n_tags');
					thisHash.forEach(item => {
						if (!item.textContent.trim()) {
							item.remove();
						}
					});
				})
			}
		}

	}

	// <車から探す>
	const searchByCar = () => {
		document.addEventListener('DOMContentLoaded', function () {
			// 遷移済みおよび同意済みフラグの取得
			const hasVisitedAgree = sessionStorage.getItem('hasVisitedAgree');
			const hasAgreed = sessionStorage.getItem('hasAgreed');

			// .containerにjs-searchByCar-vehiclelistクラスがあり、まだ同意していない場合のみ遷移
			if (document.querySelector('.container.js-searchByCar-vehiclelist') && !hasVisitedAgree && !hasAgreed) {
				// 元のURLを保存
				sessionStorage.setItem('originalURL', window.location.href);

				// 遷移済みフラグを設定
				sessionStorage.setItem('hasVisitedAgree', 'true');

				// agree.htmlへ遷移
				window.location.href = `/${basePath}/products/search-by-car/agree.html`;
			}

			// agree.html内でのクリックイベント処理
			const agreeButton = document.querySelector('.js-agree');
			const disagreeButton = document.querySelector('.js-disagree');

			if (agreeButton) {
				agreeButton.addEventListener('click', function () {
					const originalURL = sessionStorage.getItem('originalURL') || '/';

					// 同意フラグを設定して無限ループを防止
					sessionStorage.setItem('hasAgreed', 'true');

					// 不要な遷移フラグをリセット
					sessionStorage.removeItem('hasVisitedAgree');

					// 元のページに戻る
					window.location.href = originalURL;
				});
			}

			if (disagreeButton) {
				disagreeButton.addEventListener('click', function () {
					// 遷移済みフラグと同意フラグをリセット
					sessionStorage.removeItem('hasVisitedAgree');
					sessionStorage.removeItem('hasAgreed');

					// accessoriesページに遷移
					window.location.href = `/${basePath}/products/category/accessories/`;
				});
			}
		});

		// 市販製品配下における検索窓設置
		const carInputMenu = document.querySelector('.js-searchCarMenu-block');
		const carInputMenuBtn = document.querySelector('.js-searchCarMenu-btn');
		if (carInputMenuBtn && carInputMenu) {
			carInputMenu.style.height = carInputMenu.scrollHeight + 'px';
			carInputMenuBtn.addEventListener('click', (e) => {
				carInputMenuBtn.classList.toggle(a);
				carInputMenu.classList.toggle(a);
				if (carInputMenu.style.height !== '0px') {
					carInputMenu.style.height = '0px';
				} else {
					carInputMenu.style.height = carInputMenu.scrollHeight + 'px';
				}
			});
		}
	}
	// 製品詳細・横スクロールテーブルの上部にスクロールバー追加
	const productsDetailTbl01WrapBorder = () => {
		document.addEventListener('DOMContentLoaded', function() {
			if(document.querySelectorAll('.products-detail-tbl01Wrap-border').length) {
				const tableContainerWraps = document.querySelectorAll('.products-detail-tbl01Wrap-border');
				
				// 複数のテーブルコンテナに対応
				tableContainerWraps.forEach(tableContainerWrap => {
					const tableContainer = tableContainerWrap.querySelector('.products-detail-tbl01Wrap');
					const table = tableContainerWrap.querySelector('.products-detail-tbl01');
					
					if (!tableContainer || !table) return; // 必要な要素がない場合はスキップ
					
					// スクロールバー用の要素を動的に作成
					const topScroll = document.createElement('div');
					topScroll.className = 'products-detail-tbl01Wrap-border-scroll';
					const scrollInner = document.createElement('div');
					scrollInner.className = 'products-detail-tbl01Wrap-border-scroll-inner';
					
					// 要素を追加
					topScroll.appendChild(scrollInner);
					tableContainerWrap.insertBefore(topScroll, tableContainer);
					
					function updateScrollWidth() {
						if (table && scrollInner) {
							const tableWidth = table.getBoundingClientRect().width;
							scrollInner.style.width = tableWidth + 'px';
						}
					}
					
					setTimeout(updateScrollWidth, 100);
					
					// このテーブルに固有のスクロールイベントリスナーを設定
					tableContainer.addEventListener('scroll', function() {
						topScroll.scrollLeft = tableContainer.scrollLeft;
					});
					
					topScroll.addEventListener('scroll', function() {
						tableContainer.scrollLeft = topScroll.scrollLeft;
					});
					
					// Update on window resize
					const handleResize = () => updateScrollWidth();
					window.addEventListener('resize', handleResize);
					
					// Handle tab changes to recalculate width
					const tabButtons = document.querySelectorAll('.js-tab');
					tabButtons.forEach(button => {
						button.addEventListener('click', function() {
							setTimeout(updateScrollWidth, 100);
						});
					});
				});
			}
		});
	}


	// ========================================
	// TOP
	mainSplide();
	window.onload = function () {
		productsSearchForm();
	}
	featureSplide();

	// 大カテゴリ
	largeCategoryTop();
	// ソート機能付きテーブル描画
	createProductsTable();
	selectedItems();
	// 共通
	searchMenu();
	//
	if (!document.querySelector('#app')) {
		// document.addEventListener("DOMContentLoaded", () => {
		scrollTable();
		// });
	}
	caseSplide();

	// <自動車用電球・アクセサリー>
	createAccessoriesSmallCategory();
	createAccessoriesSmallCategoryHead();
	carSearchMenu();
	updatePriceDisplay();
	// <深紫外>
	uvSterilizationSmallCategoryLink();
	// <業界別ソリューション一覧>
	appRelationLinks();


	// 詳細
	detailImgSlide();
	detailCaseRemove();
	detailCaseSlide();
	detailEmptyTagRemove();
	detailEmptyRelationProductsRemove();
	detailRelationProductsLinkChange();
	detailNewMark();
	detailCreateRelationProducts();
	detailDimensions();
	detailLighting();
	detailLightingCasestudy();
	detailSeriesjudgement();

	// 特約店一覧
	networkToggle();
	// 採用事例
	caseDropDown();
	casestudy();
	// <車から探す>
	searchByCar();
	// 製品詳細・横スクロールテーブルの上部にスクロールバー追加
	productsDetailTbl01WrapBorder();


})(window.FUNCTIONS);
